export default __webpack_public_path__ + "static/media/logo.695b22dc.svg";